import { render, staticRenderFns } from "./henkilotiedot-card.vue?vue&type=template&id=68cc3861&"
import script from "./henkilotiedot-card.vue?vue&type=script&lang=ts&"
export * from "./henkilotiedot-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports